import { SVGProps } from 'react';

export default function MapPinIcon(props: SVGProps<SVGSVGElement>) {
  // TODO: Use props and remove custom width/height/viewbox

  return (
    <svg
      width="40"
      height="40"
      viewBox="0 0 40 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}>
      <g clipPath="url(#clip0_2078_80)">
        <path
          d="M14.0077 14.0723L10.6387 30.0317L3.1417 32.4491C2.4074 32.6856 1.7501 31.9211 2.09663 31.2308L9.50289 16.465C9.58815 16.2945 9.72841 16.157 9.90167 16.0717L14.0105 14.0751L14.0077 14.0723ZM16.3426 17.8236C16.0373 17.3341 15.5423 16.5008 15.1023 15.5547L12.0606 29.9574L19.3128 32.8149V21.2586C18.7243 20.9506 17.7782 20.1145 16.3426 17.8236ZM37.9069 31.2308L30.5006 16.465C30.4153 16.2945 30.2751 16.157 30.1018 16.0717L25.993 14.0751L29.362 30.0344L36.859 32.4519C37.5933 32.6884 38.2506 31.9238 37.9041 31.2335L37.9069 31.2308ZM23.6691 17.8236C22.2335 20.1228 21.282 20.9588 20.6879 21.2641V32.8176L27.9429 29.9602L24.904 15.5629C24.4639 16.5063 23.9744 17.3368 23.6691 17.8236ZM20.0004 7.41138C22.6296 7.41138 24.7582 9.54277 24.7582 12.1692C24.7582 14.7956 20.9492 20.3373 20.0004 20.3373C19.0516 20.3373 15.2425 14.7984 15.2425 12.1692C15.2425 9.54002 17.3739 7.41138 20.0004 7.41138ZM16.7744 12.1692C16.7744 13.9513 18.2182 15.3952 20.0004 15.3952C21.7825 15.3952 23.2263 13.9513 23.2263 12.1692C23.2263 10.3871 21.7825 8.94323 20.0004 8.94323C18.2182 8.94323 16.7744 10.3898 16.7744 12.1692Z"
          fill="white"
        />
      </g>
      <defs>
        <clipPath id="clip0_2078_80">
          <rect
            width="36"
            height="25.4035"
            fill="white"
            transform="translate(2 7.41138)"
          />
        </clipPath>
      </defs>
    </svg>
  );
}
